import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLanguage } from '../../../context/LanguageContext';
import './About.css';

const About: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="about-section py-5">
      <Container>

        {/* About Content */}
        <Row className="align-items-stretch">
          <Col lg={6} className="mb-4 mb-lg-0">
            <div className="about-image">
              <img 
                src="assets/img/draysesezim.webp" 
                alt="Doç. Dr. Ayşe Sezim" 
                className="img-fluid rounded"
              />
            </div>
          </Col>
          
          <Col lg={6}>
            <div className="about-content">
              <div className="luxury-title-container about-title-left">
                <h2 className="luxury-section-title">{t('about.title')}</h2>
                <div className="luxury-underline"></div>
              </div>
              
              <p className="about-text">
                {t('about.description')}
              </p>
              
              <div className="credentials">
                <h4>{t('about.credentials.title')}</h4>
                <ul>
                  <li>{t('about.credentials.item1')}</li>
                  <li>{t('about.credentials.item2')}</li>
                  <li>{t('about.credentials.item3')}</li>
                  <li>{t('about.credentials.item4')}</li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
